export default "__VITE_ASSET__BP0KSyig__"